const COUNT = new Intl.NumberFormat('en-US');

/**
 * Renders an integer count ("1,247") — entry counts, void counts, and the like
 * (admin-prototype APP-SPEC: counts in the thousands carry separators). One place
 * for the locale so admin screens can't drift apart on the separator.
 *
 * Dates are deliberately *not* en-US: `format-date.ts` uses en-GB for day-first
 * dates ("10 Jul 2026"), so the two formatters keep separate locales on purpose.
 */
export function formatCount(value: number): string {
  return COUNT.format(value);
}
